(function ($) {
	if (typeof CountUp === 'undefined') {
		return;
	}

	let $counters = null;
	let $customImages = null;
	let $customBarCharts = null;

	function setDataForStats() {
		setStaticVizStats();
		const $values = $('.count-up, .animated-counter');

		if ($values.length) {
			$values.each(wrapStatNumbers);
		}

		const $wrappedStats = $('.stat-value-countup');

		if (!$wrappedStats.length) {
			return;
		}

		$wrappedStats.each(setDataStat);
	}

	function setDataStat() {
		const $this = $(this);
		const value = $this.html().replace(/,/gi, '');

		$this.css({ minWidth: $this.width() + 10 + 'px', textAlign: 'right' });

		$this.html(0);
		$this.attr('data-count-start', 0);
		$this.attr('data-count-end', value);
	}

	function wrapStatNumbers() {
		let $this = $(this);

		// if it contains a mark use that as the wrapper
		const $mark = $this.find('mark');

		if ($mark.length) {
			$this = $mark;
		}

		const newHTML = $this
			.text()
			.replace(/[\d,\,,\.]+/g, '<span class="stat-value-countup">$&</span>');

		$this.html(newHTML);
	}

	let previousPageY = -1;

	function watchIfCountersOnScreen() {
		if (previousPageY === window.pageYOffset) {
			window.requestAnimationFrame(watchIfCountersOnScreen);
			return;
		}

		previousPageY = window.pageYOffset;

		let shouldUpdateCustomImages = false;
		let shouldUpdateBars = false;

		if ($customImages.length) {
			$customImages.each(function () {
				const $this = $(this);
				if (isOnScreen(this)) {
					shouldUpdateCustomImages = true;
					$this.removeClass('js-hide-final-custom-image');
				}
			});
		}

		if ($customBarCharts.length) {
			$customBarCharts.each(function () {
				const $this = $(this);
				if (isOnScreen(this)) {
					$this.removeClass('js-hidden-chart');
					shouldUpdateBars = true;
				}
			});
		}

		if (shouldUpdateCustomImages) {
			setCustomImages();
		}

		if (shouldUpdateBars) {
			setBars();
		}

		if ($customImages.length || $customBarCharts.length) {
			window.requestAnimationFrame(watchIfCountersOnScreen);
		}
	}

	const windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);

	function isOnScreen(elm, threshold = 200) {
		const rect = elm.getBoundingClientRect();
		const above = rect.top + threshold < windowHeight;

		return above;
	}

	function revealCounter(entry, observer) {
		if (!entry.isIntersecting) {
			return;
		}

		const $this = $(entry.target);

		if ($this.hasClass('counted')) {
			observer.unobserve(entry.target);
			return;
		}

		$this.addClass('counted');
		runCountUp($this);

		const $viz = $this.closest('.static-viz');
		if ($viz.length) {
			const $radial = $viz.find('.pie-chart');

			if ($radial.length) {
				const $fill = $radial.find('.js-animate-radial');
				const end = $fill.data('count-end') || 0;

				$fill.removeClass('js-animate-radial');
				$fill.css({ strokeDasharray: `${end} 3000` });
			}
		}

		observer.unobserve(entry.target);
	}

	const counterObserver = new IntersectionObserver(
		function (entries, observer) {
			entries.forEach(function (entry) {
				revealCounter(entry, observer);
			});
		},
		{
			threshold: 0.35,
			rootMargin: '0px 0px -8% 0px',
		},
	);

	function runCountUp($this) {
		const end = $this.data('count-end');
		const start = $this.data('count-start') || parseFloat($this.text());

		$this.data('count-start', end);

		let decimals = 0;
		const hasDecimalPlaces = end % 1;
		if (hasDecimalPlaces) {
			decimals = end.toString().split('.')[1].length || 0;
		}

		if (start !== end) {
			const duration = 0.9;
			const countUp = new CountUp($this[0], start, end, decimals, duration);
			countUp.start();

			const extraDelay = 800;

			$this.data('statHighlights').each(function (index) {
				setTimeout(
					() => {
						$(this).removeClass('force-unhighlight');
					},
					duration * 1000 + extraDelay * index,
				);
			});
		}
	}

	function setCustomImages() {
		$customImages = $('.static-viz--custom--final');
	}

	function setBars() {
		$customBarCharts = $('.static-viz--bar');
	}

	function setAllCounters() {
		$counters = $('[data-count-end]:not(".counted")');

		$counters.each(function () {
			const $this = $(this);

			$this.data(
				'statHighlights',
				$this.closest('.wp-block-group').find('.guidance-report-statistic strong'),
			);

			if ($this.data('statHighlights').length) {
				$this.data('statHighlights').addClass('force-unhighlight');
			}

			counterObserver.observe(this);
		});
	}

	setDataForStats();
	setAllCounters();

	if ($customImages.length || $customBarCharts.length) {
		setTimeout(watchIfCountersOnScreen, 1000);
	}

	window.runCountUp = runCountUp;

	function setStaticVizStats() {
		$customImages = $('.static-viz--custom--final');
		$customImages.addClass('js-hide-final-custom-image');

		$customBarCharts = $('.static-viz--bar');
		$customBarCharts.addClass('js-hidden-chart');

		const $radials = $('.pie-chart__fill');
		$radials.each(function () {
			const $this = $(this);
			const defaultDashArray = $this.attr('stroke-dasharray') || '0 3000';
			const end = defaultDashArray.split(' ')[0] || 0;
			const floatEnd = parseFloat(end);

			if (!floatEnd) {
				return;
			}

			$this.addClass('js-animate-radial');
			$this.data('count-end', floatEnd);
			$this.css({ strokeDasharray: `0 3000` });
		});
	}
})(jQuery);
